import { render, staticRenderFns } from "./BlockHero.vue?vue&type=template&id=32f41498"
import script from "./BlockHero.vue?vue&type=script&lang=js"
export * from "./BlockHero.vue?vue&type=script&lang=js"
import style0 from "./BlockHero.vue?vue&type=style&index=0&id=32f41498&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports